export function CommissioningThinking() {
  return (
    <div className="author-thinking" aria-label="studio thinking">
      <span className="author-thinking__dot" />
      <span className="author-thinking__dot" />
      <span className="author-thinking__dot" />
      <span className="author-thinking__dot" />
    </div>
  )
}
